import { render, staticRenderFns } from "./Earnings.vue?vue&type=template&id=4427a064&scoped=true"
import script from "./Earnings.vue?vue&type=script&lang=js"
export * from "./Earnings.vue?vue&type=script&lang=js"
import style0 from "./Earnings.vue?vue&type=style&index=0&id=4427a064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427a064",
  null
  
)

export default component.exports